
<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
<!--                     <div class="card-header bg-transparent pb-5">
                        <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                        <div class="btn-wrapper text-center">
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                                <span class="btn-inner--text">Github</span>
                            </a>
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                                <span class="btn-inner--text">Google</span>
                            </a>
                        </div>
                    </div> -->

                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center mb-3">
                            <h3>Reset Password</h3>
                        </div>
                         <div class="text-center mb-4">
                            <medium v-if="errors" style="color: red;">{{errors}}</medium>
                        </div>
                        <div class="text-center mb-4">
                            <medium v-if="localerrors" style="color: red;">{{localerrors}}</medium>
                        </div>
                          <form v-on:submit.prevent="onSubmit(password, confirmpassword);">
                            <fieldset class="form-group">
                            <input class="form-control" addon-left-icon="ni ni-email-83"
                                        placeholder="New Password"
                                        type="password"
                                        v-model="password"
                                        >
                            </input>
                        </fieldset>
<fieldset class="form-group">
                            <input class="form-control"
                                        placeholder="Confirm New Password"
                                        type="password"

                                        v-model="confirmpassword">
                            </input>
                        </fieldset>

                            <!-- <base-checkbox class="custom-control-alternative">
                                <span class="text-muted">Remember me</span>
                            </base-checkbox> -->
                            <div class="text-center">
                                <button v-if="!isLoading || errors" type="primary" class="btn btn-primary my-3 px-lg-8">Reset Password</button>
                                <button v-if="isLoading" type="primary" class="btn btn-primary my-3 px-lg-8">Loading..</button>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- <div class="row mt-3">
                    <div class="col-6">
                        <a href="#" class="text-light"><small>Forgot password?</small></a>
                    </div>
                    <div class="col-6 text-right">
                        <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
                    </div>
                </div> -->
            </div>
        </div>
</template>
<script>
import { mapState } from "vuex";
import { RESET_PASSWORD } from "@/store/actions.type";
  import store from "@/store";

  export default {
    name: 'resetpass',
    data() {
      return {
        email: '',
        password: '',
        confirmpassword: '',
        isLoading: false,
        localerrors : null,
        emailBlured : false,
            valid : false

      }
    },
    methods: {

        onSubmit() {
            if (this.password !== '' && this.confirmpassword !== '') {
                if (this.password !== this.confirmpassword) {
                    this.localerrors = "Passwords must match!"
                }
                else {
                    this.localerrors = null;
                    let pass = this.password;
                    Promise.all([
                      store.dispatch(RESET_PASSWORD, { pass })
                    ]).then((data) => {
                      if (Number(data[0]['errFlag']) === 0) {
                        this.$notify({
                          'type' : "success",
                          "title" : "Your Password Has Been Successfully Reset !"
                        })
                        this.isLoading = false;
                        this.$router.push({ name: "login" })
                      }
                    });
                }
            }
            else {

              this.localerrors = "Passwords cannot be empty!"

            }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        }
    },
      computed: {

        ...mapState({
          errors: state => state.auth.errors
        })
      }
  };
</script>
<style>
</style>
